import { datadogRum } from "@datadog/browser-rum";

const _initDatadog = ({ applicationId, clientToken, service }) => {
  if (["stage", "production"].includes(process.env.REACT_APP_DEPLOYMENT_ENV)) {
    datadogRum.init({
      applicationId,
      clientToken,
      site: "datadoghq.com",
      service,
      env: process.env.REACT_APP_DEPLOYMENT_ENV,
      version: process.env.REACT_APP_COMMIT_SHA,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100, // if not included, the default is 100
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
    });
    datadogRum.startSessionReplayRecording();
  }
};

export const getInfo = () => {
  return {
    link: datadogRum.getSessionReplayLink(),
    user: datadogRum.getUser(),
    context: datadogRum.getGlobalContext(),
  };
};

export const logError = (error, context) => {
  datadogRum.addError(error, context);
};

export const initDatadogScrollable = (service_name) => {
  _initDatadog({
    applicationId: "0468028d-11b4-43c2-9898-f16a018f5781",
    clientToken: "pub735c10584752d49515461d07c98ae6e0",
    service: service_name,
  });
};

export const initDatadogInteractiveInfographics = (service_name) => {
  _initDatadog({
    applicationId: "d91c6b4a-ba96-4bc9-b328-2e5faa1d75ac",
    clientToken: "pubacc05206fd9c6d1c931869987b9381b1",
    service: service_name,
  });
};

export const initDatadogSimulations = (service) => {
  _initDatadog({
    applicationId: "db1ad2ed-2ebc-4e3f-9383-b9eca26c2c52",
    clientToken: "pub05359420fd321599b99f7a5d8fb17823",
    service: service,
  });
};

export const initDatadogWidgets = (service) => {
  _initDatadog({
    applicationId: "ac8779d1-4bea-41ad-beea-516f81b1d617",
    clientToken: "pub1cfd2ba163eeb97dcb014788e7a1e424",
    service: service,
  });
};

export const initDatadogExperimentalDesigns = (service) => {
  _initDatadog({
    applicationId: "52fb2dc6-3e02-4f4d-8925-acf28211f430",
    clientToken: "pubf8e7bcb17c4edfff8aa9deef42558fbc",
    service: service,
  });
};
